export async function cryptoStrategy({
  name,
  address,
  tokenOne,
  tokenTwo,
  tokenOneAmount,
  tokenTwoAmount,
  slippage,
  NETWORK_ID_DEC,
  networkFee,
  recipientPhone,
  deposit,
  handleContractError,
}) {
  try {
    const result = await deposit({
      tokenOne,
      tokenTwo,
      slippage,
      address,
      amountIn: tokenOneAmount,
      amountOut: tokenTwoAmount,
      destChainId: NETWORK_ID_DEC,
      networkFee,

      // NEW: Send USD payout recipient
      recipientPhone,
      name,
    });

    if (!result?.success) {
      return {
        success: false,
        code: 'TX_ERROR',
        message: result?.message || 'Transaction failed',
        error: result,
      };
    }

    return result;
  } catch (err) {
    const message =
      typeof handleContractError === 'function'
        ? handleContractError(err)
        : err?.message || 'Transaction failed';

    return {
      success: false,
      code: 'TX_ERROR',
      message,
      error: err,
    };
  }
}
